module.exports = __webpack_public_path__ + "img/nyquil_severe_vapocool_cold_flu_relief_liquid.81165d26.gif";